import { render, staticRenderFns } from "./Panel.vue?vue&type=template&id=1f638718&scoped=true&"
var script = {}
import style0 from "./Panel.vue?vue&type=style&index=0&id=1f638718&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f638718",
  null
  
)

export default component.exports